// extracted by mini-css-extract-plugin
export default {"form":"FormCampaign_form__riftt","formBody":"FormCampaign_formBody__9McO0"};